import { type WidgetData } from "@repo/api";
import { trackAnalytics } from "@repo/utils";
import { useEffect } from "react";

export function useTrackWidgetAnalytics(
  widgets: WidgetData[] | undefined,
  customWorkspace?: boolean
) {
  useEffect(() => {
    const noOfWidgets = widgets?.length ?? 0;
    if (noOfWidgets > 0) {
      const widgetStatistics =
        widgets?.reduce(
          (acc, widget) => {
            acc[widget.widgetType] = (acc[widget.widgetType] ?? 0) + 1;

            return acc;
          },
          {} as Record<string, number>
        ) ?? [];

      trackAnalytics("workspace_view", {
        customWorkspace,
        numberOfWidgets: noOfWidgets,
        ...widgetStatistics,
      });
    }
  }, [widgets, customWorkspace]);
}
